import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer, Text } from '@bos/ui';
import { SnackbarIcon } from './SnackbarIcon/SnackbarIcon';
export const SnackbarContent = ({ message, variant }) => {
    const isDefaultVariant = variant === 'default';
    const maybeIconElement = !isDefaultVariant && (_jsx(SnackbarIcon, { variant: variant }));
    const gapBetweenIconAndText = isDefaultVariant ? '0' : '1';
    return (_jsxs(FlexContainer, { gap: gapBetweenIconAndText, verticalAlign: 'center', children: [maybeIconElement, _jsx(Text, { variant: 'b2', color: 'white', children: message })] }));
};
